var map = {
	"./circuit.svg": 2359,
	"./engineering.svg": 3013,
	"./facebook.svg": 3902,
	"./instagram.svg": 673,
	"./lang.svg": 5722,
	"./logistic.svg": 794,
	"./logo.svg": 3190,
	"./logo_alt.svg": 8452,
	"./oil-industry.svg": 6753,
	"./research.svg": 6195,
	"./twitter.svg": 3961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;